// REACT
import React, { Component } from 'react';

// REDUX
import * as actions from 'actions';
import { connect } from 'react-redux';

// COMPONENTS
import PhotoLogList from './PhotoLogList'
import MessageSubmitFormSC from '../Chat/MessageSubmitFormSC';
import IconCircleWrapperSC from '../Icons/Wrappers/IconCircleWrapperSC';

// UTILS
import MessageBackEnd from 'utils/ChatBackend';
const { loadMessages, sendMessage } = MessageBackEnd;
const CryptoJS = require("crypto-js");

import {encryptMessage} from '../../utils/security.js';

// VENDOR UTILS
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';

// VENDOR COMPONENTS
import AddPhoto from 'material-ui/svg-icons/image/add-a-photo';

import TextInputSC from '../../components/Chat/TextInputSC';
import SendMessageButton from '../Button/SendMessageButton';

import { checkIfReceiverIncludesStatuses } from 'utils/serviceUtils';

import { constants } from '../../constants';

import { getInteractionWidth } from 'utils/layoutUtils';
import { getMaxHeightPhotoLog } from 'utils/layoutUtils';

import Link from 'react-router-dom/Link';
import { Button } from 'components/Button/Button';

const moment = require('moment-timezone');

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {cynoEncryptionKey} from "../../utils/database/database-utils";

class PhotoLogs extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            allowedToLoadPrevious: false,
            buttonColor: '#C6CACC',
            channel: null,
            inputHeight: 58,
            loadButton: false,
            loadSpinner: false,
            loadingPrevious: false,
            messageAttributes: {},
            messages: [],
            messagesLoaded: false,
            photos: [],
            service: null,
            shouldRenderCameraScreen: false,
        };
    } 
    
    componentDidMount() {
        const { channel, userData, service, channelEncryptionKey } = this.props;
    
        // LOAD ALL MESSAGES FROM DB ON MOUNT
        this.props.loadMessages(this.loadMessages, userData.uid, service._id, service.provider, channel, 'nutritionLog', channelEncryptionKey)
        .then((messages) => {
            this.setState({
                allowedToLoadPrevious: true,
                messagesLoaded: true
            })
        })
        .catch(console.log);
    }

    componentWillReceiveProps(nextProps) {
        const { userData, service, channel, channelEncryptionKey } = nextProps;

        if (this.props.channel !== nextProps.channel) {
            // ERASE MESSAGES FROM PREVIOUS SELECTED THREAD
            this.setState({
                messages: []
            });
            
            // LOAD MESSAGES FOR WHEN NEW CLIENT/SERVICE ARE SELECTED
            this.props.loadMessages(() => {}, userData.uid, service._id, service.provider, channel, 'nutritionLog', channelEncryptionKey)
            .then((messages) => {
                this.setState({
                    allowedToLoadPrevious: true,
                    messagesLoaded: true
                })
                this.scrollToBottom();
            })
            .catch(console.log);
        }
    }

    onMessageSubmit = async (e) => {
        const mealDescription = this.mealDescription.value;
        const mealTitle = this.mealTitle.value;
        const photoInput = this.mealPhoto;
        
        e.preventDefault();
        
        if (!mealDescription || !this.state.photoUpload) {

          alert('Looks like you forgot to add a photo or its description. Both are required.');
            return false;
        }

        // console.log('PHOTO INPUT VALUE @ PhotoLog', this.state.photoUpload.file);
        // SEND MEAL DETAILS
        await this.pushMessage(this.props.client.uid, mealDescription, this.state.photoUpload && this.state.photoUpload.file, mealTitle);
        // console.log("PushMessage", this.props.client.uid, mealDescription, this.state.photoUpload && this.state.photoUpload.file, mealTitle);
        
        // RESET INPUTS
        photoInput.value = '';
        this.mealDescription.value = '';
        this.mealTitle.value='';
        this.setState({
            photoUpload: {
                file: null,
                preview: null,
            },
            buttonColor: '#C6CACC'
        });
        
        return true;
    };

    pushMessage = (recipient, mealDescription, photoFile, mealTitle) =>{
        const prevState = this.state;
        const { userData, channel, selectedClient, service } = this.props;
        
        const now = moment.utc().format('x');

        return encryptMessage(this.props.channelEncryptionKey, mealDescription, photoFile, mealTitle)
            .then((response)=> {
                // console.log('photo is encrypted: ', response);
                const newMeal = {
                    createdAt: now,
                    mealName: response.encFile.name,
                    mealDescription: response.encMessage,
                    mealTitle: (response.encTitle !== undefined) ? response.encTitle : null,
                    photoURL: (response.encFile) ? URL.createObjectURL(response.encFile) : null,
                    senderId: userData.uid,
                    senderName: `${userData.firstName} ${userData.lastName}`,
                };
                // console.log('newMeal:', newMeal);
                sendMessage({
                    createdAt: now,
                    message: newMeal,
                    photoFile: response.encFile,
                    receiverId: (selectedClient) ? selectedClient.uid : service.provider,
                    senderId: userData.uid,
                    serviceId: this.props.service._id,
                    threadId: channel,
                    type: 'nutritionLog',
                    uploadDoneCb: () => {
                        console.log(`%cFiring Action Creator for Photo Upload`, 'color: greenyellow');
                        this.props.setPhotoLogUploadingStateTo(false);
                    }
                });

                if (this.state.photoUpload && this.state.photoUpload.preview) {
                    // IF THERE IS A PHOTO SUBMITTED THEN SHOW THE UPLOAD SPINNER
                    this.props.setPhotoLogUploadingStateTo(true);
                }

                prevState.messages.push(newMeal);
                this.setState(this.state);
                this.setState({
                    shouldScrollToBottom: true
                });
            });
    };

    resetShouldScrollToBottom = () => {
        this.setState({
            shouldScrollToBottom: false
        })
    }

    // TODO: MOOVE TO UTILS
    scrollToBottom = () => {
        // TODO: ========= 
        // might be good to show an indicator when a new message arrives while the user is scrolled up looking at chat history so they know to scroll down to view the new message. 
        // I dont like the idea of forcing a scroll down when they are viewing old messages.
        // They can click on the indicator to scroll to the bottom/new messages and hide the indicator
        // ===============
        const scrollHeight = this.chat.scrollHeight;
        const height = this.chat.clientHeight;
        const maxScrollTop = scrollHeight - height;
        this.chat.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }

    loadMoreMessages = () => {
        return new Promise((resolve, reject) => {
            this.props.loadPastMessages((messArray) => {
                // console.log('messArray', messArray);
                resolve(messArray);
            }, this.props.service.provider, this.props.messagesRedux && this.props.messagesRedux[0]._id, this.props.channel, 'nutritionLog')
        });
    };

    getSenderName = (message) => {
        return (!this.props.client.provider && !this.props.selectedClient)
            ? `${this.props.client.firstName} ${this.props.client.lastName}` 
            : `${this.props.selectedClient.firstName} ${this.props.selectedClient.lastName}`;
    }

    loadMessages = (messages) => {
        // console.log('MESSAGES @ LOAD MESSAGES', messages);
        let restructuredMessages = this.getRestructuredMessages({messages: messages});
        // console.log('RESTRUCTURED MESSAGES', restructuredMessages);
        
        this.setState((prevState) => {
            if (prevState.messages.length > 19) {
                // prevState.messages.splice(prevState.messages.length - 1, 1); // prevents duplicate
                return {
                    loadButton: true,
                    messages: [...prevState.messages, ...restructuredMessages],
                };
            } else {
                return {
                    messages: (prevState && prevState.messages.length > 0) ? [...prevState.messages, ...restructuredMessages] : [...restructuredMessages],
                };
            }
        });
    };

    handlePhotoUpload = (event) => {
        // Show photo thumb that was uploaded
        const file = event.target.files[0];
        const photoPreviewURL = URL.createObjectURL(file);

        this.setState({
            photoUpload: {
                file: file,
                preview: photoPreviewURL,
            }
        });
        // console.log('PHOTO PREVIEW', photoPreviewURL);
    };

    handleSetButtonColor = (e) => {
        if (e.target.value.length > 0){
         this.setState({
             buttonColor: '#4AC4D1'
         })
        } else {
         this.setState({
             buttonColor: '#C6CACC'
         })
        }
     }

    isMobileBrowser = function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    onInputBlur = () => {
        if (this.isMobileBrowser()) {
            this.props.toggleShouldShowToolbarTo(true);
        }
    }

    onInputFocus = () => {
        if (this.isMobileBrowser()) {
            this.props.toggleShouldShowToolbarTo(false);
        }
    }

    render() {
        const { channel, userData, selectedClient, service, isModulePartOfService } = this.props;
        if (this.state.messages && this.state.messages.length > 0 ) {
            // console.log('LOAD MORE?', this.state.messages[this.state.messages.length - 1].id, this.state.messages.length, this.state.messages.length - 1 /*this.state.messages[this.state.messages.length - 1].id*/);
        }
        // console.log('EXPIRATION CHECKER:', this.props.filteredServices, service);

        return (
            <div id={'outerChatContainerStyles'} style={styles.outerChatContainerStyles}>
                <div id={'innerChatContainerStyles'} style={styles.innerChatContainerStyles}>
                        { this.props.height && userData &&
                            <PhotoLogList
                                maxHeight={ getMaxHeightPhotoLog(this.state, userData, this.state.inputHeight) }
                                loadMoreMessages={ this.loadMoreMessages }
                                // allowedToLoadPrevious={this.state.allowedToLoadPrevious}
                                messagesLoaded={ this.state.messagesLoaded }
                                shouldScrollToBottom={ this.state.shouldScrollToBottom }
                                resetShouldScrollToBottom={ this.resetShouldScrollToBottom }
                                userData={ userData }
                                selectedClient={ selectedClient }
                                selectedService={ service }
                                channel={ channel }
                                provider={ (service) ? service.provider : null }
                                windowHeight={this.props.height}
                                windowWidth={this.props.width}
                                isModulePartOfService={isModulePartOfService}
                            />
                        }
                    { !this.props.client.provider && !checkIfReceiverIncludesStatuses(service, ['active', 'pending'], this.props.filteredReceivers) && isModulePartOfService &&
                        <React.Fragment>
                            <p style={{ textAlign: 'center', fontSize: 14, color: 'darkred', fontWeight: 'bold', margin: '0 auto' }}>Sending messages is not available for expired services.</p>

                            {/* TEMPORARILY DEACTIVE REPEATS UNTIL PUCHASE BYPASS IS DONE */}
                            {/* <p style={{ textAlign: 'center', fontSize: 14 }}>If you enjoyed this service, you can repeat it by clicking below:</p>
                            <Link style={{ textDecoration: 'none', margin: '0 auto' }} to={`/service/detail/${service._id}`}>
                                <Button>
                                    <FontAwesomeIcon 
                                        icon={['fas', 'redo-alt']}
                                        style={{ marginRight: 15 }}
                                        size={10}
                                    /> 
                                    Repeat Service
                                </Button>
                            </Link> */}

                            {/* ONCE RATINGS ARE DONE THIS CAN BE UNCOMMENTED */}
                            {/* <p style={{ textAlign: 'center', fontSize: 14 }}>OR</p>
                            <Button backgroundColor="#0ad6df">
                                <FontAwesomeIcon 
                                    icon={['fas', 'comment']}
                                    style={{ marginRight: 15 }}
                                    size={10}
                                /> 
                                Leave Feedback
                            </Button> */}
                        </React.Fragment>
                    }
                    { !this.props.client.provider && checkIfReceiverIncludesStatuses(service, ['active', 'pending'], this.props.filteredReceivers) && isModulePartOfService &&
                        <MessageSubmitFormSC onSubmit={e => this.onMessageSubmit(e)} width={getInteractionWidth(this.state)} maxWidth={constants.layout.InteractionPanel.maxWidth} minHeight={this.state.inputHeight}>
                            <label htmlFor="photo" style={{ cursor: 'pointer' }}>
                                <AddPhoto style={{ paddingLeft: 20, cursor: 'pointer' }} /> {/* if a webcam is detected show a popup giving choice of file upload or web cam */}
                            </label>
                            { this.state.photoUpload && this.state.photoUpload.preview &&
                                <img src={this.state.photoUpload && this.state.photoUpload.preview} alt="" style={{ paddingLeft: 15, width: 30, height: 30,  }}/>
                            }
                            <div 
                                style={{
                                    display: 'flex', 
                                    flex: 1, 
                                    flexDirection: 'column', 
                                    paddingLeft: 25,
                                    maxWidth: '50%',
                                }}
                            >
                                <input 
                                    onKeyUp={ this.handleSetButtonColor }
                                    type="text"
                                    placeholder="Add a Photo Title"
                                    ref={t => this.mealTitle = t }
                                    style={{ ...styles.chatInputStyles }}
                                    onFocus={this.onInputFocus}
                                    onBlur={this.onInputBlur}
                                />
                                <input 
                                    style={{ display: 'none' }}
                                    type="file" 
                                    accept="image/*" 
                                    id="photo" 
                                    ref={m => {
                                        this.mealPhoto = m;
                                    }}
                                    onChange={this.handlePhotoUpload}
                                />
                                <input
                                    onKeyUp={ this.handleSetButtonColor }
                                    ref={m => {
                                        this.mealDescription = m;
                                    }}
                                    placeholder="Describe your photo..."
                                    style={{...styles.chatInputStyles}} //, paddingLeft: (this.state.photoUpload && this.state.photoUpload.preview) ? 70 : 30 
                                    onFocus={this.onInputFocus}
                                    onBlur={this.onInputBlur}
                                />
                            </div>
                            <button type="submit" style={{ backgroundColor: 'transparent', borderWidth: 0, paddingRight: 20 }}>
                                <SendMessageButton buttonBackgroundColor={ this.state.buttonColor }/>
                                {/* <IconCircleWrapperSC color={ this.state.buttonColor }>
                                    <UpArrow style={{ width: 30, height: 30, color: 'white' }}/> 
                                </IconCircleWrapperSC> */}
                            </button>
                        </MessageSubmitFormSC>
                    }
                </div>
        </div>
        );
    }
}

// const { width: viewportWidth, height: viewportHeight } = Dimensions.get('window');

const mapStateToProps = ({ chat, client, provider, service }) => {
    // console.log('GOT NEW CHANNEL?', chat.messageThread);
    const { logMessages, messageThread: channel, msgKey: channelEncryptionKey } = chat;
    return {
        channel,
        channelEncryptionKey,
        filteredReceivers: {
            activeReceivers: service.activeServices,
            inactiveReceivers: service.inactiveServices,
            pendingReceivers: service.pendingServices,
        },
        messagesRedux: logMessages,
        selectedClient: provider.selectedClient,
        userData: client.clientData,
    };
};

export default connect(mapStateToProps, actions)(PhotoLogs);

const styles = {
    button: {
        backgroundColor: '#fff',
        borderColor: '#1D2129',
        borderRadius: 20,
        borderStyle: 'solid',
        borderWidth: 2,
        color: '#1D2129',
        fontSize: 18,
        fontWeight: '300',
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
    },
    chatInputStyles: {  
        border: 'none',
        borderTop: '0px solid #ddd',
        display: 'flex',
        flex: 1,
        fontSize: '16px',
        outlineWidth: 0,
    },
    innerChatContainerStyles: {
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
        flex: 1,
        maxHeight: '100%',
        maxWidth: '100%',
    },
    outerChatContainerStyles: {
        alignItems: 'flex-end',
        alignSelf: 'flex-end',
        display: 'flex',
        flex: 1,
        alignItems: 'stretch',
        maxHeight: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
    },
    selected: {
        backgroundColor: '#0084FF',
        borderColor: '#0084FF',
        color: '#fff',
    },
}



// WEBPACK FOOTER //
// ./src/js/components/PhotoLogs/PhotoLog.jsx